import { render, staticRenderFns } from "./PanelCompetitionPaymentResult.vue?vue&type=template&id=1231addf&scoped=true&"
import script from "./PanelCompetitionPaymentResult.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionPaymentResult.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionPaymentResult.vue?vue&type=style&index=0&id=1231addf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231addf",
  null
  
)

export default component.exports